import { configureStore } from '@reduxjs/toolkit'
import { muifReducers } from 'medere-ui-framework'
import ValidationViewSlice from './slices/ValidationViewSlice'



export const store = configureStore({
  reducer: {
    ...muifReducers,
    validationView: ValidationViewSlice,
  },
})

export function clearStore() {
}

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

